<div *blockUI="'section-block'">
    <button type="button" class="btn btn-success mb-2" rippleEffect (click)="showCreateVault()" *ngIf="authService.isEndpointStatus('POST.Writing.CreateVault')">
        <span [data-feather]="'credit-card'" [class]="'mr-25'"></span>Hesap Ekle</button>
    <div class="row match-height">
        <div class="col-xl-4 col-lg-6 col-md-12 mb-xl-3 mb-lg-2 mb-md-1 mb-0" *ngFor="let item of vaults">
            <div class="card">
                <div class="card-header d-flex justify-content-between pb-0">
                    <h4 class="card-title">{{item.title}}</h4>
                    <div ngbDropdown class="chart-dropdown">
                        <button class="btn btn-sm border-0 p-50" ngbDropdownToggle type="button" id="dropdownItem4"
                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                            (click)="showDetail(item.id)" *ngIf="authService.isEndpointStatus('GET.Reading.GetByIdVault')">
                            <span [data-feather]="'eye'"></span>
                            {{item.typeName}}
                        </button>
                    </div>
                </div>


                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-2 col-12 d-flex flex-column flex-wrap text-center">
                            <p class="card-text mb-20">Toplam Tutar</p>
                            <span class="font-large-1 font-weight-bold">{{item.totalPrice | number:'1.2-2'}}</span>
                        </div>
                    </div>
                    <div class="d-flex justify-content-between mt-3">
                        <div class="text-center">
                            <p class="card-text mb-50">Toplam Hareket</p>
                            <span class="font-large-1">{{item.totalMovementCount}}</span>
                        </div>
                        <div class="text-center">
                            <p class="card-text mb-50">Son Hareket Tarihi</p>
                            <span class="font-large-1">{{item.endMovementDate | date:'dd.MM.yyyy'}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-12 d-flex justify-content-between">
            <p>Toplam Veri <strong>{{totalCount}}</strong></p>
            <ngb-pagination [collectionSize]="totalCount" [(page)]="pageBasic" [pageSize]="selectedSize"
                [directionLinks]="true" (pageChange)="onPageChange($event)" [maxSize]="5">
            </ngb-pagination>
        </div>
    </div>
</div>